import React from "react"

import { ProjectChild } from "shared/types/Project"
import { ProjectChildMultiActionCallbacks } from "shared/types/ProjectChild"

import { ProjectChildMultiSelectSidebarView } from "./ProjectChildMultiSelectSidebarView"
import { useProjectChildMultiSelectSidebarViewModel } from "./hooks/useProjectChildMultiSelectSidebarViewModel"

export interface ProjectChildMultiSelectSidebarModel {
  selectedChildren: ProjectChild[]
  callbacks: ProjectChildMultiActionCallbacks

  isDisabled?: boolean

  hideControls?: boolean
}

export interface ProjectChildMultiSelectSidebarProps
  extends ProjectChildMultiSelectSidebarModel {}

export const ProjectChildMultiSelectSidebar = React.memo(
  (props: ProjectChildMultiSelectSidebarProps) => (
    <ProjectChildMultiSelectSidebarView
      {...useProjectChildMultiSelectSidebarViewModel(props)}
    />
  )
)
